module.exports = __webpack_public_path__ + "img/logo_bw.f1934921.png";